/*
 * Dubai Looka — recently viewed.
 *
 * Two jobs:
 *   1. On a product page, record the handle in this browser's own history.
 *   2. Anywhere the section is placed, fill it with the most recent handles.
 *
 * Cards are fetched from the recently-viewed-card section rather than built
 * here from product JSON. Requesting a section against a product URL renders it
 * in that product's context, so the markup that comes back is the real Dawn
 * card -- percent badge, NEW ribbon, free-shipping chip, quick-add and all --
 * and it cannot drift from card-product.liquid the way hand-built markup would.
 *
 * Nothing leaves the browser. The history is never sent anywhere.
 */
(function () {
  const KEY = 'dl-recently-viewed';
  const MAX_STORED = 20;

  /* Safari private mode throws on write; an uncaught throw here would abort
     everything after it. Same wrapper as countdown-timer.js. */
  function read() {
    try {
      const raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {
      /* Storage unavailable; the row simply stays empty. */
    }
  }

  function record(handle) {
    if (!handle) return;
    const list = read().filter((h) => h !== handle);
    list.unshift(handle);
    write(list.slice(0, MAX_STORED));
  }

  if (!customElements.get('recently-viewed')) {
    customElements.define(
      'recently-viewed',
      class RecentlyViewed extends HTMLElement {
        connectedCallback() {
          const current = this.dataset.current || null;
          /* Record before reading, so the row on a product page excludes the
             product being looked at rather than showing it back to the user. */
          if (current) record(current);

          const limit = parseInt(this.dataset.limit, 10) || 8;
          const handles = read()
            .filter((h) => h !== current)
            .slice(0, limit);

          if (!handles.length) {
            this.remove();
            return;
          }

          this.render(handles);
        }

        async render(handles) {
          const track = this.querySelector('[data-recently-viewed-track]');
          if (!track) return;

          const cards = await Promise.all(
            handles.map((handle) =>
              fetch(`${window.routes ? '' : ''}/products/${encodeURIComponent(handle)}?section_id=recently-viewed-card`)
                .then((response) => (response.ok ? response.text() : null))
                .catch(() => null)
            )
          );

          const frag = document.createDocumentFragment();
          cards.forEach((html) => {
            if (!html) return;
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const card = parsed.querySelector('.card-wrapper');
            if (!card) return;
            const li = document.createElement('li');
            li.className = 'recently-viewed__item';
            li.appendChild(card);
            frag.appendChild(li);
          });

          /* A handle can 404 if the product was unpublished since it was seen. */
          if (!frag.childElementCount) {
            this.remove();
            return;
          }

          track.appendChild(frag);
          this.hidden = false;
        }
      }
    );
  }

  /* Product pages that do not carry the section still need to record a visit. */
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('recently-viewed')) return;
    const el = document.querySelector('[data-recently-viewed-handle]');
    if (el) record(el.dataset.recentlyViewedHandle);
  });
})();
